// Native replacements for the lodash functions used across AgentPortal.
// Signatures match lodash so call sites are drop-in replacements.

// Group an array by a key (string) or iteratee (function). Returns { [key]: [...] }.
export const groupBy = (arr, iter) => {
  const fn = typeof iter === 'function' ? iter : (item) => item[iter];
  return arr.reduce((acc, item) => {
    const k = fn(item);
    (acc[k] ??= []).push(item);
    return acc;
  }, {});
};

// Unique by key/iteratee. Preserves first-seen order.
export const uniqBy = (arr, iter) => {
  const fn = typeof iter === 'function' ? iter : (item) => item[iter];
  const seen = new Set();
  return arr.filter((item) => {
    const k = fn(item);
    if (seen.has(k)) return false;
    seen.add(k);
    return true;
  });
};

// Sort by one iteratee or array of iteratees. Returns NEW array, doesn't mutate.
// Lodash signature: orderBy(collection, [iteratees], [orders])
export const orderBy = (arr, iteratees, orders = []) => {
  const fns = (Array.isArray(iteratees) ? iteratees : [iteratees]).map((it) =>
    typeof it === 'function' ? it : (item) => item[it]
  );
  const dirs = Array.isArray(orders) ? orders : [orders];
  return [...arr].sort((a, b) => {
    for (let i = 0; i < fns.length; i++) {
      const av = fns[i](a);
      const bv = fns[i](b);
      const dir = dirs[i] === 'desc' ? -1 : 1;
      if (av < bv) return -1 * dir;
      if (av > bv) return 1 * dir;
    }
    return 0;
  });
};

// Standard debounce. Returns a function with a .cancel() method.
export const debounce = (fn, wait) => {
  let timer;
  const debounced = (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), wait);
  };
  debounced.cancel = () => clearTimeout(timer);
  return debounced;
};
